import React from 'react';
import PropTypes from 'prop-types';
import theme from '../../styles/theme';
import { Container, Background } from './styles';

function Account({ children }) {
  return (
    <>
      <Background theme={theme} />
      <Container>{children}</Container>
    </>
  );
}

Account.propTypes = {
  children: PropTypes.node.isRequired,
};

Account.displayName = 'Account';

export default Account;
